<h1 mat-dialog-title>
  {{ 'dataManagement.directory.dialog.dataExchangeRequest.title' | transloco }}
</h1>

<mat-dialog-content>
  <form [formGroup]="requestForm">

    <div class="exchange-card">
      <mat-form-field appearance="outline" class="full-width" style="padding-top: 16px;">
        <mat-label>{{ 'dataManagement.directory.dialog.dataExchangeRequest.nameLabel' | transloco }}</mat-label>
        <input matInput formControlName="nameControl" maxlength="200" />
        <mat-error *ngIf="nameCtrl.hasError('required')">
          {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="exchange-card">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'dataManagement.directory.dialog.dataExchangeRequest.deadlineLabel' | transloco }}</mat-label>
        <input matInput [matDatepicker]="deadlinePicker" formControlName="deadlineControl" [min]="minSelectableDeadline">
        <mat-datepicker-toggle matSuffix [for]="deadlinePicker"></mat-datepicker-toggle>
        <mat-datepicker #deadlinePicker></mat-datepicker>
        <mat-error *ngIf="deadlineCtrl.hasError('matDatepickerMin')">
          {{ 'dataManagement.directory.dialog.dataExchangeRequest.deadlineInPastError' | transloco }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="exchange-card">
      <mat-label>{{ 'dataManagement.directory.dialog.dataExchangeRequest.recipientLabel' | transloco }}</mat-label>
      <mat-form-field class="chip-list" appearance="outline">
        <mat-chip-grid #chipGrid>
          <mat-chip-row *ngIf="selectedPrincipal" (removed)="removePrincipal()">
            {{ selectedPrincipal.name }}
            <button matChipRemove aria-label="remove recipient">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        </mat-chip-grid>
        <input
          placeholder="{{ selectedPrincipal ? '' : ('dataManagement.directory.dialog.dataExchangeRequest.addRecipient' | transloco) }}"
          #principalInput
          [formControl]="principalCtrl"
          [matChipInputFor]="chipGrid"
          [matAutocomplete]="auto"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" />
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectPrincipal($event.option.value)">
          <mat-option *ngFor="let principal of filteredPrincipals | async" [value]="principal">
            {{ principal.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div class="exchange-card summary-card">
      <mat-label class="label-large">
        {{ 'dataManagement.directory.dialog.dataExchangeRequest.selectionSummary' | transloco }}
      </mat-label>
      <ul class="summary-list">
        <li *ngIf="packagingSystemIds.length > 0">
          {{ 'dataManagement.directory.dialog.dataExchangeRequest.packagingSystemsCount' | transloco: { count: packagingSystemIds.length } }}
        </li>
        <li *ngIf="packagingUnitIds.length > 0">
          {{ 'dataManagement.directory.dialog.dataExchangeRequest.packagingUnitsCount' | transloco: { count: packagingUnitIds.length } }}
        </li>
        <li *ngIf="componentIds.length > 0">
          {{ 'dataManagement.directory.dialog.dataExchangeRequest.componentsCount' | transloco: { count: componentIds.length } }}
        </li>
        <li *ngIf="materialIds.length > 0">
          {{ 'dataManagement.directory.dialog.dataExchangeRequest.materialsCount' | transloco: { count: materialIds.length } }}
        </li>
      </ul>
      <mat-label class="label-hint">
        {{ 'dataManagement.directory.dialog.dataExchangeRequest.totalCount' | transloco: { count: totalItemCount } }}
      </mat-label>
    </div>

    <div class="exchange-card">
      <mat-form-field appearance="outline" class="full-width comment-form-field">
        <mat-label>{{ 'dataManagement.directory.dialog.dataExchangeRequest.commentLabel' | transloco }}</mat-label>
        <textarea class="no-resize-textarea" matInput formControlName="commentControl" maxlength="250"></textarea>
      </mat-form-field>
    </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button color="primary"
    (click)="confirm()"
    [disabled]="!selectedPrincipal || !isFormValid()"
    type="submit">
    {{ 'common.buttons.confirm' | transloco }}
  </button>
  <button mat-raised-button (click)="cancel()" type="button">
    {{ 'common.buttons.cancel' | transloco }}
  </button>
</mat-dialog-actions>
